import React, {useState, useContext, useEffect} from 'react';
import { IonSlides, IonSlide, IonImg, IonModal, IonGrid, IonRow, IonCol, IonButton, IonHeader, IonContent, IonFooter, IonItem } from '@ionic/react';

import '../../../css/layout.css'
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { TakePhoto, photos } from '../../../zInternal_Features/merchant/components/TakePhoto';


export function ShowPortfolioPicsModal (props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [accessRights, setAccessRights ] = useState(authenticatedMerchent_context.accessRights);

    let [showPasswordModal, setShowPasswordModal] = useState(false); 

    let [productImageNumber, setProductImageNumber] = useState(null);

    let [takePhotoStatus1, setTakePhotoStatus1] = useState(false);
    let [takePhotoStatus2, setTakePhotoStatus2] = useState(false);
    let [takePhotoStatus3, setTakePhotoStatus3] = useState(false);
    let [takePhotoStatus4, setTakePhotoStatus4] = useState(false);
    let [takePhotoStatus5, setTakePhotoStatus5] = useState(false);
    let [takePhotoStatus6, setTakePhotoStatus6] = useState(false);
    let [takePhotoStatus7, setTakePhotoStatus7] = useState(false);
    let [takePhotoStatus8, setTakePhotoStatus8] = useState(false);

    let [selectedFile, setSelectedFile] = useState(null);



    function selectedFileHandler1(event)
    {
        setProductImageNumber("1");
        setSelectedFile(event);
        setTakePhotoStatus1(false);
        uploadProductImage(event, "1");
    }

    function selectedFileHandler2(event)
    {
        setProductImageNumber("2");
        setSelectedFile(event);
        setTakePhotoStatus2(false);
        uploadProductImage(event, "2");

    }
    function selectedFileHandler3(event)
    {
        setProductImageNumber("3");
        setSelectedFile(event);
        setTakePhotoStatus3(false);
        uploadProductImage(event, "3");

    }
    function selectedFileHandler4(event)
    {
        setProductImageNumber("4");
        setSelectedFile(event);
        setTakePhotoStatus4(false);
        uploadProductImage(event, "4");

    }
    function selectedFileHandler5(event)
    {
        setProductImageNumber("5");
        setSelectedFile(event);
        setTakePhotoStatus5(false);
        uploadProductImage(event, "5");

    }
        function selectedFileHandler6(event)
    {
        setProductImageNumber("6");
        setSelectedFile(event);
        setTakePhotoStatus6(false);
        uploadProductImage(event, "6");

    }
        function selectedFileHandler7(event)
    {
        setProductImageNumber("7");
        setSelectedFile(event);
        setTakePhotoStatus7(false);
        uploadProductImage(event, "7");

    }
        function selectedFileHandler8(event)
    {
        setProductImageNumber("8");
        setSelectedFile(event);
        setTakePhotoStatus8(false);
        uploadProductImage(event, "8");
    }

    function handleFileChange(event) {

        //alert("in HadndleFileChange");
        //alert(event.target.dataset.id);
        // alert(event.target);
        // alert(event.target.files);
        // alert(event.target.files[0]);

        const file = event.target.files ? event.target.files[0] : null;
        setProductImageNumber(event.target.dataset.id);
        setSelectedFile(file);

        uploadProductImage(file, event.target.dataset.id);
    }

    function handleEnterAttachement(event) {  

        fetch(baseURL+'fileServer/merchants/attachment-not-available.png')
        .then(res => res.blob())
        .then(data => {

            const blobUrl = URL.createObjectURL(data);

            let noImageFile = new File([data], blobUrl, {
                enctype: 'multipart/form-data',
                type: 'image/jpeg',
                name: 'xImageFile',
                accept: "image/*",
            });
            
            setProductImageNumber(event[0]);
            setSelectedFile(noImageFile);

            alert("No Photo Option checked");
        })
    }



    function uploadProductImage(file, imageNumber)
    {
    
        let formData = new FormData();
        formData.append('Tracker', '74300_Pic_proService');
        formData.append('user', acctID);
        formData.append('merchantSchema', schema);
        formData.append('xPortfolioID', props.data.portfolioID);
        formData.append('xPortfolioImageNumber', imageNumber);
        formData.append('xImageFile', file);
        //formData.append('xEnterAdminPassword', accessRights[0]);
        formData.append('sessionID', sessionID);
    
        const requestOptions = {
            enctype: 'multipart/form-data',
            method: 'POST',
            //credentials: 'include',
            file: formData,
            body: formData,
            contentType: false,
            processData: false,
    
            // body: JSON.stringify({
            //     Tracker: '74300_Pic',
            //     user: acctID,
            //     xInventoryProductID: props.data.productID,
            //     xProductImageNumber: productImageNumber,
            //     xImageFile: selectedFile,
            //     xEnterAdminPassword: enteredPassword,
            //     sessionID: sessionID,
            // }),
        }
    
        fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {
    
            alert(data);
    
            props.closeModal_2nd();
    
        })
        .catch(error => {
            console.error(error);
        })
    }
    
    function closeModalHandler() {
    
        props.closeModal(false);
    }
    
    //alert('Inside ShowProductPicsModal');
    //alert(props.data.productPic1);
    //alert(props.data.productPic2);
    //alert(props.data.productPic3);
    //alert(props.data.productPic4);
    
    return (
        <React.Fragment>
        {props.openModal == true ?
            (
        <IonModal id='showProductPics' isOpen={ props.openModal }>
        <IonContent className='grid_content_90_percent'>
            <IonSlides pager='true' options={{direction: 'horizontal'}}>
                <IonSlide>
                    <IonGrid className='grid_content_100_percent'>
                        <IonRow>
                            <IonCol> 1/8 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>                            
                                <IonButton  onClick={() => setTakePhotoStatus1(true)}> Take Photo</IonButton>
                                {takePhotoStatus1 == true && <TakePhoto onSelectedFile={selectedFileHandler1}></TakePhoto>}
                            </IonCol>
                            <IonCol>
                                <input
                                    type="file"
                                    accept="image/jpeg"
                                    data-id='1'
                                    onChange={handleFileChange}
                                />
                            </IonCol>
                        </IonRow>
                        {/*<IonRow>
                            <IonCol>
                                <label for='noAttachment'>No Attachment</label>
                            </IonCol>
                            <IonCol>
                                <input type='checkbox' id='noAttachment' onClick={() => handleEnterAttachement(['1'])}></input>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonButton onClick={() => uploadProductImage()}> Submit Upload </IonButton>
                            </IonCol>
                        </IonRow>*/}
                        <IonRow>
                            <IonCol>
                                <IonImg src={`/api/image/${props.data.portfolioPic1}/${schema}`} />

                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>
                <IonSlide>
                    <IonGrid  className='grid_content_100_percent'>
                        <IonRow>
                            <IonCol> 2/8 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>                            
                                <IonButton  onClick={() => setTakePhotoStatus2(true)}> Take Photo</IonButton>
                                {takePhotoStatus2 == true && <TakePhoto onSelectedFile={selectedFileHandler2}></TakePhoto>}
                            </IonCol>
                            <IonCol>
                                <input
                                    type="file"
                                    accept="image/jpeg"
                                    data-id='2'
                                    onChange={handleFileChange}
                                />
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonImg src={`/api/image/${props.data.portfolioPic2}/${schema}`} />
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>
                <IonSlide>
                    <IonGrid  className='grid_content_100_percent'>
                        <IonRow>
                            <IonCol> 3/8 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>                            
                                <IonButton  onClick={() => setTakePhotoStatus3(true)}> Take Photo</IonButton>
                                {takePhotoStatus3 == true && <TakePhoto onSelectedFile={selectedFileHandler3}></TakePhoto>}
                            </IonCol>
                            <IonCol>
                                <input
                                    type="file"
                                    accept="image/jpeg"
                                    data-id='3'
                                    onChange={handleFileChange}
                                />
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonImg src={`/api/image/${props.data.portfolioPic3}/${schema}`} />
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>
                <IonSlide>
                    <IonGrid  className='grid_content_100_percent'>
                        <IonRow>
                            <IonCol> 4/8 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>                            
                                <IonButton  onClick={() => setTakePhotoStatus4(true)}> Take Photo</IonButton>
                                {takePhotoStatus4 == true && <TakePhoto onSelectedFile={selectedFileHandler4}></TakePhoto>}
                            </IonCol>
                            <IonCol>
                                <input
                                    type="file"
                                    accept="image/jpeg"
                                    data-id='4'
                                    onChange={handleFileChange}
                                />
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonImg src={`/api/image/${props.data.portfolioPic4}/${schema}`} />
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>
                <IonSlide>
                    <IonGrid  className='grid_content_100_percent'>
                        <IonRow>
                            <IonCol> 5/8 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>                            
                                <IonButton  onClick={() => setTakePhotoStatus5(true)}> Take Photo</IonButton>
                                {takePhotoStatus5 == true && <TakePhoto onSelectedFile={selectedFileHandler5}></TakePhoto>}
                            </IonCol>
                            <IonCol>
                                <input
                                    type="file"
                                    accept="image/jpeg"
                                    data-id='5'
                                    onChange={handleFileChange}
                                />
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonImg src={`/api/image/${props.data.portfolioPic5}/${schema}`} />
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>
                                <IonSlide>
                    <IonGrid  className='grid_content_100_percent'>
                        <IonRow>
                            <IonCol> 6/8 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>                            
                                <IonButton  onClick={() => setTakePhotoStatus6(true)}> Take Photo</IonButton>
                                {takePhotoStatus6 == true && <TakePhoto onSelectedFile={selectedFileHandler6}></TakePhoto>}
                            </IonCol>
                            <IonCol>
                                <input
                                    type="file"
                                    accept="image/jpeg"
                                    data-id='6'
                                    onChange={handleFileChange}
                                />
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonImg src={`/api/image/${props.data.portfolioPic6}/${schema}`} />
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>
                                <IonSlide>
                    <IonGrid  className='grid_content_100_percent'>
                        <IonRow>
                            <IonCol> 7/8 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>                            
                                <IonButton  onClick={() => setTakePhotoStatus7(true)}> Take Photo</IonButton>
                                {takePhotoStatus7 == true && <TakePhoto onSelectedFile={selectedFileHandler7}></TakePhoto>}
                            </IonCol>
                            <IonCol>
                                <input
                                    type="file"
                                    accept="image/jpeg"
                                    data-id='7'
                                    onChange={handleFileChange}
                                />
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonImg src={`/api/image/${props.data.portfolioPic7}/${schema}`} />
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>
                <IonSlide>
                    <IonGrid  className='grid_content_100_percent'>
                        <IonRow>
                            <IonCol> 8/8 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>                            
                                <IonButton  onClick={() => setTakePhotoStatus8(true)}> Take Photo</IonButton>
                                {takePhotoStatus8 == true && <TakePhoto onSelectedFile={selectedFileHandler8}></TakePhoto>}
                            </IonCol>
                            <IonCol>
                                <input
                                    type="file"
                                    accept="image/jpeg"
                                    data-id='8'
                                    onChange={handleFileChange}
                                />
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonImg src={`/api/image/${props.data.portfolioPic8}/${schema}`} />
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>
            </IonSlides>
        </IonContent>
    
        <IonFooter class='grid_footer'>
    
            <IonButton onClick={closeModalHandler}> Close </IonButton>
    
        </IonFooter>
    
        {/*<EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>   */}                     
    
        </IonModal>) : null }
        </React.Fragment>
    )
}